const desigual = {
  createTitle: "Añadir Proveedor",
  editTitle: "Editar Proveedor",
  exportAllSuppliers: "Exportar todos los proveedores",
  exportAllSuppliersConfirmation:
    "¿Está seguro de que desea exportar todos los proveedores a un archivo CSV?",
  exportCsvFailed: "Error al exportar el CSV",
  savedMessage: "Proveedor guardado con éxito",
  createdMessage: "Proveedor creado con éxito",
  updatedMessage: "Proveedor actualizado con éxito",
  stepRequester: "Solicitante",
  stepSupplierData: "Datos del Proveedor",
  stepAddress: "Dirección",
  stepContacts: "Contactos",
  stepBanking: "Datos Bancarios",
  stepCurrency: "Moneda",
  stepPaymentTerms: "Plazos de Pago",
  stepPaymentMethod: "Método de Pago",
  stepBilling: "Facturación",
  stepDocuments: "Documentos",
  viewDocCodeOfEthics: "Código ético",
  viewDocTermsAndConditions:
    "Términos y condiciones generales de contratación de Desigual",
  viewDocDataProcessingAgreement: "Contrato de tratamiento de datos personales",
  viewDocument: "Ver Documento",
  requesterName: "Nombre del Solicitante",
  requesterEmail: "Email del Solicitante",
  supplierEmail: "Email de Contacto (Proveedor)",
  dossierApprover: "Aprobador AP",
  businessApprover: "Aprobador de Negocio",
  activationDate: "Fecha de Activación",
  companyIds: "IDs de Empresa",
  category: "Categoría",
  supplierName: "Nombre del Proveedor",
  vatNif: "IVA / NIF",
  entityType: "Persona Física / Jurídica",
  withholdingTax: "Retención",
  withholdingTaxRate: "Porcentaje de Retención (%)",
  street: "Calle",
  streetNumber: "Número",
  city: "Ciudad",
  regionProvince: "Región / Provincia",
  postalCode: "Código Postal",
  country: "País",
  contact: "Contacto",
  addContact: "Añadir Contacto",
  fullName: "Nombre Completo",
  language: "Idioma",
  phone: "Teléfono",
  orderEmail: "Email de Pedidos",
  bankName: "Nombre del Banco",
  bankCode: "Código Bancario",
  accountNumber: "Número de Cuenta",
  checkDigit: "Dígito de Control",
  iban: "IBAN",
  swiftBic: "SWIFT / BIC",
  intermediaryBank: "Banco Intermediario",
  intermediaryBic: "BIC Intermediario",
  currency: "Moneda",
  paymentTerm: "Plazo de Pago",
  paymentTermOther: "Especificación de Otro Plazo",
  paymentMethod: "Método de Pago",
  instructionKey: "Clave de Instrucción de Facturación",
  accountGroup: "Grupo de Cuentas de Facturación",
  purchasingOrganisation: "Organización de Compras",
  purchasingGroup: "Grupo de Compras",
  internalSupplierId: "ID Interno del Proveedor",
  treasuryGroup: "Grupo de Tesorería",
  bankCertificate: "Certificado Bancario",
  bankCertDate: "Fecha de Emisión del Certificado Bancario",
  bankCertExpiry: "Fecha de Vencimiento del Certificado Bancario",
  taxCertificate: "Certificado de Residencia Fiscal",
  taxCertIssue: "Fecha de Emisión del Certificado Fiscal",
  taxCertExpiry: "Fecha de Vencimiento del Certificado Fiscal",
  contractWithDesigual: "Contrato con Desigual",
  tcApproval: "Acepto los Términos y Condiciones",
  tcQuestion: "¿Acepta los Términos y Condiciones Generales?",
  tcHelper:
    'Si selecciona "No", suba su contrato firmado con Desigual como justificación.',
  optional: "opcional",
  yes: "Sí",
  no: "No",
  individual: "Persona Física",
  legal: "Persona Jurídica",
  general: "Compras Generales",
  product: "Producto",
  freight: "Transitarios",
  "30d": "30 Días",
  "60d": "60 Días",
  "90d": "90 Días",
  other: "Otro",
  directDebit: "Débito Directo",
  letterOfCredit: "Carta de Crédito",
  confirming: "Confirmando",
  transfer: "Transferencia",
  common: {
    cancel: "Cancelar",
    save: "Guardar",
    saveWithoutReset: "Guardar sin restablecer estado",
    submit: "Enviar",
    update: "Actualizar",
    back: "Atrás",
    next: "Siguiente",
  },
  validation: {
    requesterName: { required: "El nombre del solicitante es obligatorio" },
    requesterEmail: {
      required: "El email del solicitante es obligatorio",
      invalid: "Dirección de email inválida",
    },
    supplierEmail: {
      required: "El email del proveedor es obligatorio",
      invalid: "Dirección de email inválida",
    },
    dossierApproverEmail: {
      required: "El aprobador del expediente es obligatorio",
    },
    businessApproverEmail: {
      required: "El aprobador de negocio es obligatorio",
    },
    companyIds: { required: "Al menos un ID de empresa es obligatorio" },
    category: { required: "La categoría es obligatoria" },
    purchasingOrganisation: {
      required: "La organización de compras es obligatoria",
    },
    withholdingTaxRate: { range: "Debe estar entre 0 y 100" },
    orderEmail: { invalid: "Dirección de email inválida" },
    taxCertExpiryDate: {
      afterIssue: "La fecha de vencimiento debe ser posterior a la de emisión",
      required: "La fecha de vencimiento del certificado fiscal es obligatoria",
    },
    contractWithDesigual: {
      required: "Por favor suba su contrato firmado con Desigual",
    },
    supplierName: { required: "El nombre del proveedor es obligatorio" },
    registrationNumber: { required: "El número de registro es obligatorio" },
    entityType: { required: "Persona Física / Jurídica es obligatorio" },
    street: { required: "La calle es obligatoria" },
    streetNumber: { required: "El número es obligatorio" },
    city: { required: "La ciudad es obligatoria" },
    regionProvince: { required: "La región / provincia es obligatoria" },
    postalCode: { required: "El código postal es obligatorio" },
    country: { required: "El país es obligatorio" },
    contactFullName: { required: "El nombre completo es obligatorio" },
    contactLanguage: { required: "El idioma es obligatorio" },
    contactNumber: {
      required: "El teléfono es obligatorio",
      invalid: "El teléfono solo debe contener dígitos",
      maxLength: "El teléfono debe tener como máximo 15 dígitos",
    },
    contactOrderEmail: { required: "El email de pedidos es obligatorio" },
    bankName: { required: "El nombre del banco es obligatorio" },
    bankCode: { required: "El código bancario es obligatorio" },
    bankAccountNumber: { required: "El número de cuenta es obligatorio" },
    bankCheckDigit: { required: "El dígito de control es obligatorio" },
    iban: { required: "El IBAN es obligatorio" },
    bic: { required: "El SWIFT / BIC es obligatorio" },
    intermediaryBank: { required: "El banco intermediario es obligatorio" },
    currency: { required: "La moneda es obligatoria" },
    paymentTerm: { required: "El plazo de pago es obligatorio" },
    paymentTermDescription: {
      required: "La especificación de otro plazo es obligatoria",
    },
    paymentMethod: { required: "El método de pago es obligatorio" },
    billingInstructionKey: {
      required: "La clave de instrucción de facturación es obligatoria",
    },
    billingAccountGroup: {
      required: "El grupo de cuentas de facturación es obligatorio",
    },
    purchasingGroup: { required: "El grupo de compras es obligatorio" },
    internalSupplierId: {
      required: "El ID interno del proveedor es obligatorio",
    },
    treasuryGroup: { required: "El grupo de tesorería es obligatorio" },
    bankCertificate: { required: "El certificado bancario es obligatorio" },
    bankCertIssueDate: {
      required: "La fecha de emisión del certificado bancario es obligatoria",
    },
    bankCertExpiryDate: {
      required:
        "La fecha de vencimiento del certificado bancario es obligatoria",
    },
    taxResidenceCertificate: {
      required: "El certificado de residencia fiscal es obligatorio",
    },
    taxCertIssueDate: {
      required: "La fecha de emisión del certificado fiscal es obligatoria",
    },
  },
};

export default desigual;
